export default {
  text_one: 'Verdiene {{count}} Punkt',
  text_other: 'Verdiene {{count}} Punkte',
};
